import React, { Component, useEffect } from "react";
import { Card } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Breadcrumb } from "@gull";
import { Formik } from "formik";

import { useState } from "react";

import * as yup from "yup";
import { RenderTextArea, RenderTextInput } from "app/common/renderInput";
import { getRoles } from "app/services/permissionService";
import { editUserData } from "app/services/UserService";
import { NotificationManager } from "react-notifications";
import { useLocation, useNavigate } from "react-router-dom";

const validationModel = yup.object().shape({
  firstName: yup.string().required("First name is required!"),
  lastName: yup.string().required("Last name is required!"),

  username: yup.string().required("User name is required!"),
  email: yup
    .string()
    .email("Please enter valid email")
    .required("Email is required!"),
  phoneNumber: yup
    .string()
    .min(6, "Minimum 6 digits are required")
    .max(10, "Maximum 10 digits allowed")
    .required("phoneNumber is required!"),

  address: yup.string().required("Address is required!"),
  roleId: yup.number().required("Role is required!"),
});
export { validationModel };

function EditUser(props) {
  const { state } = useLocation();
  console.log(state);

  const Navigate = useNavigate();

  const [roleData, setRoleData] = useState([]);

  const loadRoles = async () => {
    const response = await getRoles();

    const data = response.data;

    const demo = {
      roleId: 0,
      roleName: "---Select Role---",
      description: "",
      isLocked: false,
      userCount: "",
    };
    setRoleData((x) => [demo, ...data]);
  };
  useEffect(() => {
    loadRoles();
  }, []);

  const editUserHandler = async (values) => {
    const res = await editUserData(values.userId, values);
    console.log(res);
    if (res.status == "Success") {
      NotificationManager.success(res.message);

      Navigate("/admin/users/users");
    } else {
      NotificationManager.error(res.message);
    }
  };
  return (
    <div>
      <Helmet>
        <title>Add User</title>
      </Helmet>

      <Breadcrumb
        routeSegments={[
          { name: "Users", path: "/admin/users/users" },
          { name: "Edit User" },
        ]}
      ></Breadcrumb>

      <Card className="p-4">
        <Formik
          initialValues={state}
          validationSchema={validationModel}
          onSubmit={editUserHandler}
          enableReinitialize
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }) => {
            return (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label
                        htmlFor="firstName"
                        className="font-weight-bold"
                        style={{ fontSize: "15px" }}
                      >
                        First name
                        <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        name="firstName"
                        id="firstName"
                        className={
                          touched.firstName && errors.firstName
                            ? "error form-control customInput"
                            : "form-control customInput"
                        }
                        placeholder="FirstName"
                        value={values.firstName}
                        error={errors.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {errors.firstName}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label
                        htmlFor="lastName"
                        className="font-weight-bold"
                        style={{ fontSize: "15px" }}
                      >
                        Last name
                        <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        name="lastName"
                        className={
                          touched.lastName && errors.lastName
                            ? "error form-control customInput"
                            : "form-control customInput"
                        }
                        placeholder="Email"
                        value={values.lastName}
                        error={errors.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {errors.lastName}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label
                        htmlFor="username"
                        className="font-weight-bold"
                        style={{ fontSize: "15px" }}
                      >
                        User name
                        <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        name="username"
                        id="username"
                        className={
                          touched.username && errors.username
                            ? "error form-control customInput"
                            : "form-control customInput"
                        }
                        placeholder="Bank Name"
                        value={values.username}
                        error={errors.username}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled
                      />
                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {errors.username}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label
                        className="font-weight-bold"
                        style={{ fontSize: "15px" }}
                      >
                        Email
                        <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        name="email"
                        className={
                          touched.email && errors.email
                            ? "error form-control customInput"
                            : "form-control customInput"
                        }
                        placeholder="Email"
                        value={values.email}
                        error={errors.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled
                      />
                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {errors.email}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label
                        className="font-weight-bold"
                        style={{ fontSize: "15px" }}
                      >
                        Phone No.
                        <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        name="phoneNumber"
                        className={
                          touched.phoneNumber && errors.phoneNumber
                            ? "error form-control customInput"
                            : "form-control customInput"
                        }
                        placeholder="Mobile no."
                        value={values.phoneNumber}
                        error={errors.phoneNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {errors.phoneNumber}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label
                        className="font-weight-bold"
                        style={{ fontSize: "15px" }}
                      >
                        Role
                      </label>
                      <select
                        className="form-select mb-3"
                        aria-label="Default select example"
                        value={values.roleId}
                        error={errors.roleId}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          setFieldValue("roleId", e.target.value);
                        }}
                      >
                        {roleData.map((x) => (
                          <option value={x.roleId} key={x.roleId}>
                            {x.roleName}
                          </option>
                        ))}
                      </select>

                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {touched.roleId && errors.roleId}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-12">
                    <RenderTextArea
                      name="address"
                      placeholder="Address"
                      value={values.address}
                      error={errors.address}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>

                  <div className="col-md-6 col-12 d-flex flex-row-reverse">
                    <button
                      type="submit"
                      className="btn btn-primary editUserBtn align-self-center"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </Card>
    </div>
  );
}

export default EditUser;
